import * as React from "react";
import type { SVGProps } from "react";
const SvgCalendar04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M3.875 8.469h15.75M5.911 2v1.688M17.375 2v1.688m0 0H6.125A3.375 3.375 0 0 0 2.75 7.063v11.25a3.375 3.375 0 0 0 3.375 3.375h11.25a3.375 3.375 0 0 0 3.375-3.375V7.063a3.375 3.375 0 0 0-3.375-3.375m3.375 11.53h-6.187m0 0H8.936m5.626 0v5.626m0-5.625V9.03M8.936 15.22H2.75m6.188 0v5.625m0-5.625V9.03"
    />
  </svg>
);
export default SvgCalendar04;
